var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("modal", {
    attrs: {
      "show-on-mount": "",
      options: {
        close: {
          onEsc: false,
          onBlur: false
        }
      }
    },
    on: {
      hide: function($event) {
        return _vm.cancel()
      }
    },
    scopedSlots: _vm._u([
      {
        key: "modal-title",
        fn: function() {
          return [_c("h3", [_vm._v(_vm._s(_vm.resources.title))])]
        },
        proxy: true
      },
      {
        key: "modal-body",
        fn: function() {
          return [
            _c("div", { staticClass: "row form-group" }, [
              _c("div", { staticClass: "col-12" }, [
                _vm._v(
                  "\n                " +
                    _vm._s(_vm.resources.description) +
                    "\n            "
                )
              ])
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "row form-group option-container" }, [
              _c("div", { staticClass: "col-12 option-label" }, [
                _vm._v(
                  "\n                " +
                    _vm._s(_vm.resources.actionLabel) +
                    "\n            "
                )
              ]),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "col-12 option-choice" },
                [
                  _c(
                    "selectable-button",
                    {
                      attrs: { option: _vm.OPTIONS.ACTIONS.pause },
                      model: {
                        value: _vm.action,
                        callback: function($$v) {
                          _vm.action = $$v
                        },
                        expression: "action"
                      }
                    },
                    [
                      _vm._v(
                        "\n                    " +
                          _vm._s(
                            _vm.resource(
                              "JourneyBuilder_DeactivateConfirmationPopup_Pause"
                            )
                          ) +
                          "\n                "
                      )
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "selectable-button",
                    {
                      attrs: { option: _vm.OPTIONS.ACTIONS.stop },
                      model: {
                        value: _vm.action,
                        callback: function($$v) {
                          _vm.action = $$v
                        },
                        expression: "action"
                      }
                    },
                    [
                      _vm._v(
                        "\n                    " +
                          _vm._s(
                            _vm.resource(
                              "JourneyBuilder_DeactivateConfirmationPopup_Stop"
                            )
                          ) +
                          "\n                "
                      )
                    ]
                  )
                ],
                1
              )
            ]),
            _vm._v(" "),
            _vm.action === _vm.OPTIONS.ACTIONS.pause
              ? _c("div", { staticClass: "row form-group option-container" }, [
                  _c("div", { staticClass: "col-12 option-label" }, [
                    _vm._v(
                      "\n                " +
                        _vm._s(_vm.resources.pauseDurationTypeLabel) +
                        "\n            "
                    )
                  ]),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "col-12 option-choice" },
                    [
                      _c(
                        "selectable-button",
                        {
                          attrs: {
                            option: _vm.OPTIONS.PAUSE_DURATION_TYPES.indefinite
                          },
                          model: {
                            value: _vm.pauseDurationType,
                            callback: function($$v) {
                              _vm.pauseDurationType = $$v
                            },
                            expression: "pauseDurationType"
                          }
                        },
                        [
                          _vm._v(
                            "\n                    " +
                              _vm._s(
                                _vm.resource(
                                  "JourneyBuilder_DeactivateConfirmationPopup_PauseDurationIndefinite"
                                )
                              ) +
                              "\n                "
                          )
                        ]
                      ),
                      _vm._v(" "),
                      _c(
                        "selectable-button",
                        {
                          attrs: {
                            option: _vm.OPTIONS.PAUSE_DURATION_TYPES.period
                          },
                          model: {
                            value: _vm.pauseDurationType,
                            callback: function($$v) {
                              _vm.pauseDurationType = $$v
                            },
                            expression: "pauseDurationType"
                          }
                        },
                        [
                          _vm._v(
                            "\n                    " +
                              _vm._s(
                                _vm.resource(
                                  "JourneyBuilder_DeactivateConfirmationPopup_PauseDurationPeriod"
                                )
                              ) +
                              "\n                "
                          )
                        ]
                      ),
                      _vm._v(" "),
                      _c(
                        "div",
                        { staticClass: "d-inline-block" },
                        [
                          _vm.pauseDurationType ===
                          _vm.OPTIONS.PAUSE_DURATION_TYPES.period
                            ? _c("jira-style-time-period", {
                                model: {
                                  value: _vm.pauseDuration,
                                  callback: function($$v) {
                                    _vm.pauseDuration = $$v
                                  },
                                  expression: "pauseDuration"
                                }
                              })
                            : _vm._e()
                        ],
                        1
                      )
                    ],
                    1
                  )
                ])
              : _vm._e(),
            _vm._v(" "),
            _vm.pauseDurationType ===
              _vm.OPTIONS.PAUSE_DURATION_TYPES.indefinite ||
            (_vm.pauseDuration && _vm.pauseDuration.seconds)
              ? _c("div", { staticClass: "row form-group option-container" }, [
                  _c("div", { staticClass: "col-12 option-label" }, [
                    _vm._v(
                      "\n                " +
                        _vm._s(_vm.resources.pauseFinishedObjectActionLabel) +
                        "\n            "
                    )
                  ]),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "col-12 option-choice" },
                    [
                      _c(
                        "selectable-button",
                        {
                          attrs: {
                            option:
                              _vm.OPTIONS.PAUSE_FINISHED_OBJECT_ACTION
                                .reactivate
                          },
                          model: {
                            value: _vm.pauseFinishedObjectAction,
                            callback: function($$v) {
                              _vm.pauseFinishedObjectAction = $$v
                            },
                            expression: "pauseFinishedObjectAction"
                          }
                        },
                        [
                          _vm._v(
                            "\n                    " +
                              _vm._s(
                                _vm.resource(
                                  "JourneyBuilder_DeactivateConfirmationPopup_Reactivate"
                                )
                              ) +
                              "\n                "
                          )
                        ]
                      ),
                      _vm._v(" "),
                      _c(
                        "selectable-button",
                        {
                          attrs: {
                            option:
                              _vm.OPTIONS.PAUSE_FINISHED_OBJECT_ACTION.stop
                          },
                          model: {
                            value: _vm.pauseFinishedObjectAction,
                            callback: function($$v) {
                              _vm.pauseFinishedObjectAction = $$v
                            },
                            expression: "pauseFinishedObjectAction"
                          }
                        },
                        [
                          _vm._v(
                            "\n                    " +
                              _vm._s(
                                _vm.resource(
                                  "JourneyBuilder_DeactivateConfirmationPopup_Stop"
                                )
                              ) +
                              "\n                "
                          )
                        ]
                      )
                    ],
                    1
                  )
                ])
              : _vm._e(),
            _vm._v(" "),
            _vm.pauseFinishedObjectAction ===
            _vm.OPTIONS.PAUSE_FINISHED_OBJECT_ACTION.reactivate
              ? _c("div", { staticClass: "row form-group option-container" }, [
                  _c("div", { staticClass: "col-12 option-label" }, [
                    _vm._v(
                      "\n                " +
                        _vm._s(_vm.resources.pauseFinishedRecordActionLabel) +
                        "\n            "
                    )
                  ]),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "col-12 option-choice" },
                    [
                      _c(
                        "selectable-button",
                        {
                          attrs: {
                            option:
                              _vm.OPTIONS.PAUSE_FINISHED_RECORDS_ACTION.process
                          },
                          model: {
                            value: _vm.pauseFinishedRecordAction,
                            callback: function($$v) {
                              _vm.pauseFinishedRecordAction = $$v
                            },
                            expression: "pauseFinishedRecordAction"
                          }
                        },
                        [
                          _vm._v(
                            "\n                    " +
                              _vm._s(
                                _vm.resource(
                                  "JourneyBuilder_DeactivateConfirmationPopup_Process"
                                )
                              ) +
                              "\n                "
                          )
                        ]
                      ),
                      _vm._v(" "),
                      _c(
                        "selectable-button",
                        {
                          attrs: {
                            option:
                              _vm.OPTIONS.PAUSE_FINISHED_RECORDS_ACTION.delete
                          },
                          model: {
                            value: _vm.pauseFinishedRecordAction,
                            callback: function($$v) {
                              _vm.pauseFinishedRecordAction = $$v
                            },
                            expression: "pauseFinishedRecordAction"
                          }
                        },
                        [
                          _vm._v(
                            "\n                    " +
                              _vm._s(
                                _vm.resource(
                                  "JourneyBuilder_DeactivateConfirmationPopup_Delete"
                                )
                              ) +
                              "\n                "
                          )
                        ]
                      )
                    ],
                    1
                  )
                ])
              : _vm._e(),
            _vm._v(" "),
            _vm.isFinished
              ? _c("div", { staticClass: "row form-group" }, [
                  _c(
                    "div",
                    { staticClass: "col-12 summary" },
                    [
                      _vm.willDeleteRecords
                        ? [
                            _vm._v(
                              "\n                    " +
                                _vm._s(_vm.resources.summaryWithDelete) +
                                "\n                "
                            )
                          ]
                        : [
                            _vm._v(
                              "\n                    " +
                                _vm._s(_vm.resources.summaryWithPause) +
                                "\n                "
                            )
                          ],
                      _vm._v(" "),
                      _c("br"),
                      _vm._v(" "),
                      _c("br"),
                      _vm._v(
                        "\n                " +
                          _vm._s(_vm.resources.confirmation) +
                          "\n            "
                      )
                    ],
                    2
                  )
                ])
              : _vm._e()
          ]
        },
        proxy: true
      },
      {
        key: "modal-footer",
        fn: function() {
          return [
            _c("div", { staticClass: "w-100" }, [
              _c(
                "button",
                {
                  staticClass: "float-left btn btn-danger",
                  on: {
                    click: function($event) {
                      return _vm.cancel()
                    }
                  }
                },
                [
                  _c("i", { staticClass: "fa fa-trash" }),
                  _vm._v(
                    " " +
                      _vm._s(_vm.resource("Button_Cancel")) +
                      "\n            "
                  )
                ]
              ),
              _vm._v(" "),
              _vm.isFinished
                ? _c(
                    "button",
                    {
                      staticClass: "float-right btn btn-success",
                      on: {
                        click: function($event) {
                          return _vm.save()
                        }
                      }
                    },
                    [
                      _c("i", { staticClass: "fa fa-save" }),
                      _vm._v(
                        " " +
                          _vm._s(_vm.resource("Button_Save")) +
                          "\n            "
                      )
                    ]
                  )
                : _vm._e()
            ])
          ]
        },
        proxy: true
      }
    ])
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }